import React, { useEffect, useState, useRef } from "react";
import api from "../../api";
import { useParams, useNavigate } from "react-router-dom";

export default function SupportTicketView() {
  const { id } = useParams();
  const nav = useNavigate();

  const [ticket, setTicket] = useState(null);
  const [loading, setLoading] = useState(true);

  const bottomRef = useRef(null);

  /* ================= LOAD TICKET ================= */
  useEffect(() => {
    const loadTicket = async () => {
      try {
        const res = await api.get(`/support/student/ticket/${id}`);
        setTicket(res.data);
      } catch (err) {
        console.error(err);
        alert("Failed to load support ticket");
        nav("/student/support");
      } finally {
        setLoading(false);
      }
    };

    loadTicket();
  }, [id, nav]);

  /* ================= AUTO SCROLL ================= */
  useEffect(() => {
    bottomRef.current?.scrollIntoView({ behavior: "smooth" });
  }, [ticket]);

  if (loading) {
    return <p style={{ padding: 30 }}>⏳ Loading ticket...</p>;
  }

  if (!ticket) {
    return <p style={{ padding: 30 }}>Ticket not found.</p>;
  }

  return (
    <div style={pageStyle}>
      <div style={overlayStyle}>
        <div style={cardStyle}>
          {/* ================= HEADER ================= */}
          <div style={headerStyle}>
            <img src="/logo.png" alt="EduAt10" style={logoStyle} />

            <button
              onClick={() => nav("/student/support")}
              style={backBtnStyle}
            >
              ← Back to Tickets
            </button>
          </div>

          <h2 style={{ marginBottom: 6 }}>{ticket.title}</h2>
          <p style={{ marginBottom: 14 }}>
            <strong>Status:</strong>{" "}
            <span style={{ color: statusColor(ticket.status) }}>
              {ticket.status}
            </span>
          </p>

          {/* ================= MESSAGES ================= */}
          <div style={chatBoxStyle}>
            {ticket.messages.length === 0 && (
              <p style={{ textAlign: "center", color: "#64748b" }}>
                No messages yet
              </p>
            )}

            {ticket.messages.map((m, i) => (
              <div
                key={i}
                style={{
                  ...msgStyle,
                  alignSelf:
                    m.sender === "student" ? "flex-end" : "flex-start",
                  background:
                    m.sender === "student" ? "#2563eb" : "#e5e7eb",
                  color: m.sender === "student" ? "#fff" : "#000",
                }}
              >
                <div style={{ fontSize: 12, opacity: 0.8 }}>
                  {m.sender === "student" ? "You" : "Support"}
                </div>
                <div>{m.message}</div>
              </div>
            ))}

            <div ref={bottomRef} />
          </div>
        </div>
      </div>
    </div>
  );
}

/* ================= HELPERS ================= */
function statusColor(status) {
  if (!status) return "#334155";
  if (status.toLowerCase().includes("open")) return "#2563eb";
  if (status.toLowerCase().includes("close")) return "#16a34a";
  return "#f59e0b";
}

/* ================= STYLES ================= */
const pageStyle = {
  minHeight: "100vh",
  backgroundImage: "url('/eduat10-bg.png')",
  backgroundSize: "cover",
  backgroundPosition: "center",
};

const overlayStyle = {
  minHeight: "100vh",
  backgroundColor: "rgba(0,0,0,0.25)",
  padding: 20,
};

const cardStyle = {
  maxWidth: 900,
  margin: "auto",
  background: "rgba(255,255,255,0.95)",
  borderRadius: 16,
  padding: 24,
  display: "flex",
  flexDirection: "column",
};

const headerStyle = {
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  marginBottom: 12,
};

const logoStyle = {
  width: 110,
};

const backBtnStyle = {
  padding: "8px 14px",
  background: "#e2e8f0",
  border: "none",
  borderRadius: 8,
  cursor: "pointer",
};

const chatBoxStyle = {
  flex: 1,
  border: "1px solid #e5e7eb",
  borderRadius: 10,
  padding: 12,
  display: "flex",
  flexDirection: "column",
  gap: 8,
  overflowY: "auto",
};

const msgStyle = {
  maxWidth: "70%",
  padding: "8px 12px",
  borderRadius: 12,
  fontSize: 14,
};
